import React from 'react';
import PropTypes from 'prop-types';

import ModalView from '../modalView';

import '../style.sass';

const EditNote = (props) => {
  const { t } = props;
  return (
    <ModalView
      title={t('Edit note')}
      titleAction={t('Save')}
      {...props}
    />
  );
};

EditNote.propTypes = {
  t: PropTypes.func.isRequired,
};

export default EditNote;
